import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 300px 0 0 400px;
`;
